export type FuelProductType = "oil" | "pellets";

export const STANDARD_PELLETS_QUANTITY = 6000;
